import { Modal, Form, Input } from 'antd'
import { useCreateWorkspace, useCreateWorkspaceModal } from '~/app/services/workspace'
import { CreateWorkspacePayload } from '~/app/services/workspace'

export default function CreateWorkspaceModal() {
  const [form] = Form.useForm()
  const { isOpen, setIsOpen } = useCreateWorkspaceModal()
  const { mutate: createWorkspace, isPending } = useCreateWorkspace()

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values: CreateWorkspacePayload) => {
        createWorkspace(values, {
          onSuccess: () => {
            form.resetFields()
            setIsOpen(false)
          },
        })
      })
      .catch((info) => {
        console.log('Validation Failed:', info)
      })
  }

  const handleCancel = () => {
    form.resetFields()
    setIsOpen(false)
  }

  return (
    <Modal
      title="Create New Workspace"
      open={isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={isPending}
      okText="Create"
      cancelText="Cancel"
    >
      <Form
        form={form}
        layout="vertical"
        name="create_workspace"
        autoComplete="off"
      >
        <Form.Item
          label="Workspace Name"
          name="name"
          rules={[
            { required: true, message: 'Please enter workspace name' },
            { min: 3, message: 'Workspace name must be at least 3 characters' },
            { max: 50, message: 'Workspace name must not exceed 50 characters' },
          ]}
        >
          <Input placeholder="Enter workspace name" />
        </Form.Item>

        <Form.Item
          label="Avatar URL (Optional)"
          name="avatar"
          rules={[
            { type: 'url', message: 'Please enter a valid URL' },
          ]}
        >
          <Input placeholder="https://example.com/avatar.png" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
